import React from 'react'
import { Flex } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import { ActiveStyle } from './ActiveStyle';
import { Icon } from '@chakra-ui/react';

export default function NavItem(props) {
    const pathName = useLocation().pathname;
    const { icon, children, ...rest } = props;
    return (

        <Flex
            {...(pathName === props.linkto && ActiveStyle)}
            align="center"
            px="4"
            pl="4"
            py="3"
            cursor="pointer"
            _hover={{
                ...ActiveStyle,
            }}
            role="group"
            transition=".15s ease"
            {...rest}
        >
            {icon && <Icon mr="2" boxSize="4" _groupHover={{}} as={icon} />}
            {children}
        </Flex>
    );
}
